export interface InlineLabelSegment {
  bold: boolean;
  text: string;
}

export function splitInlineLabelSegments(text: string): InlineLabelSegment[] {
  if (!text) return [];

  const segments: InlineLabelSegment[] = [];
  const matcher = /\*\*([^*]+)\*\*/g;
  let startIndex = 0;
  let match: RegExpExecArray | null = matcher.exec(text);

  while (match) {
    const [token, boldText] = match;
    const tokenIndex = match.index;

    if (tokenIndex > startIndex) {
      segments.push({
        bold: false,
        text: text.slice(startIndex, tokenIndex),
      });
    }

    segments.push({
      bold: true,
      text: boldText,
    });

    startIndex = tokenIndex + token.length;
    match = matcher.exec(text);
  }

  if (startIndex < text.length) {
    segments.push({
      bold: false,
      text: text.slice(startIndex),
    });
  }

  return segments;
}
